import React, { useState, forwardRef, useEffect } from "react";

import { InputTextarea } from "primereact/inputtextarea";
import { useParams } from "react-router-dom";
import MeaUpdateModal from "../../../../components/MeaUpdateModal";
import attendancesAPI from "../../../../services/attendances";

const UpdateAttendanceMessageModal = forwardRef((props, ref) => {
  const params = useParams();
  const schoolId = props.schoolId || params.schoolId;
  const trainingId = props.trainingId || params.trainingId;
  const accessToken = props.accessToken || "";
  const [message, setMessage] = useState("");
  //
  useEffect(() => {
    setMessage(props?.attendance?.message);
  }, [props]);
  //
  return (
    <>
      <MeaUpdateModal
        ref={ref}
        title="Justificatif"
        schoolId={schoolId}
        trainingId={trainingId}
        accessToken={accessToken}
        serviceAPI={attendancesAPI}
        id={props?.attendance?.id}
        data={{
          message: message,
        }}
      >

        <label htmlFor="delay" className="block text-900 font-medium mb-2">
          Message
        </label>
        <InputTextarea
          id="delay"
          autoFocus={true}
          type="text"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          rows={3}
          className="w-full mb-3"
        />

      </MeaUpdateModal>
    </>
  );
});

export default UpdateAttendanceMessageModal;
